<template>
  <div>
    <v-snackbar top right color="primary" v-model="snackbar" :timeout="5000">Failed to authenticate</v-snackbar>

    <v-row class="text-center">
      <v-col cols="12">
        <v-img :src="require('../assets/logo.svg')" class="my-3" contain height="100" />
      </v-col>

      <v-col offset-md="4" md="4" offset-sm="2" sm="8" offset-xs="0" xs="12">
        <v-text-field
          :rules="[rules.required, rules.min]"
          label="Email"
          hint="At least 8 characters"
          counter
          prepend-inner-icon="mdi-account"
          @click:append="show = !show"
          v-model="email"
          filled
        />

        <v-text-field
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min]"
          :type="show ? 'text' : 'password'"
          label="Password"
          hint="At least 8 characters"
          counter
          prepend-inner-icon="mdi-key"
          @click:append="show = !show"
          v-model="password"
          filled
        />
        <v-btn color="primary" :disabled="loginDisabled" @click="login" elevation="0" large block>Login</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Home extends Vue {
  private password = ''
  private email = ''
  show = false
  snackbar = false

  rules = {
    required: (value: string): boolean | string => !!value || 'Required.',
    min: (v: string): boolean | string => v.length >= 4 || 'Min 4 characters'
  }

  get loginDisabled(): boolean {
    const noPassword = !this.password || !this.password.length || this.password.length < 4
    const noUser = !this.email || !this.email.length || this.email.length < 8
    return noPassword || noUser
  }

  async login(): Promise<void> {
    if (this.loginDisabled) return

    try {
      await this.$store.dispatch('login', { password: this.password, email: this.email })
      this.$router.push({ name: 'Dashboard' })
    } catch (error) {
      this.snackbar = true
    }
  }
}
</script>
